// ajax-utils
$.ajaxSetup({ global: true });
var ajaxUtilsSettings =
{
	enableAutoBrowserHistoryUpdate: false,
	scrollToTopOfTargetContainer: true,
	// used mainly to compensate for fixed-position page headers that are not properly handled by the current scrollTop implementation
	scrollTopDelta: 0
};

function useAjaxAutoBrowserHistoryUpdate() {
	ajaxUtilsSettings.enableAutoBrowserHistoryUpdate = true;

	// initial state
	window.history.replaceState({ url: window.location.href }, null, window.location.href);

	$(document).ajaxSuccess(function (e1, xhr, options, data) {
		if (!ajaxUtilsSettings.enableAutoBrowserHistoryUpdate || (options.context && options.context.noHistoryUpdate)) return;
		if (options.type === 'GET') {
			var url = options.url;
			window.history.pushState({ url: url }, null, url);
		}
	});
	$(window).on('popstate', function (e1) {
		if (!ajaxUtilsSettings.enableAutoBrowserHistoryUpdate) return;
		if (e1.originalEvent.state && e1.originalEvent.state) {
			window.location.assign(e1.originalEvent.state.url);
		}
		else {
			console.log('History state not available');
		}
	});
}

$(document).ajaxError(function (event, jqxhr, settings, thrownError) {
	$('.global-error h3.error-code').text(jqxhr.status);
	$('.global-error span.error-message').text(jqxhr.statusText);
	$('html,body').animate({ scrollTop: 0 }, 500);
	$('.global-error').fadeIn(200);
});

function ajaxUtils(container) {
	container = container ? container : $(document);
	setObservers(container);
	var fullRefreshAfterResponse = false;
	var fullRefreshLocation = null;

	function getAjaxParam(item, key) {
		return $(item).data(key) || $(item).closest('.ajax-link,.ajax-form').data(key);
	}
	//function pushUrl(source, url) {
	//	if (!ajaxUtilsSettings.disableBrowserHistoryUpdate && window.history && !getAjaxParam(source, 'ajax-no-url-update')) {
	//		window.history.pushState({ url: url }, null, url);
	//	}
	//	return url;
	//}

	$('.auto-submit', container).change(function (e) {
		var form = $(e.currentTarget).closest('form');
		var targetButton = $(e.currentTarget).data("auto-submit-target");
		if (targetButton) $(targetButton, form).click();
		else form.submit();
	});

	$('.ajax-full-refresh', container).click(function (e) {
		fullRefreshAfterResponse = true;
		fullRefreshLocation = $(e.currentTarget).data('ajax-full-refresh-location');
	});

	function getUpdateMethod(selector) {
		var $selector = $(selector);
		var updateMode = $selector.data('ajax-update-mode');
		var targetContainer = $selector.parent();
		var targetIndex = $selector.index();
		switch (updateMode) {
			case "replace-content":
				return function (targetSelector, data) {
					if (checkFullRedirectDirective(data)) return;
					$(targetSelector).html(data);
					var newTarget = $(targetSelector);
					if (newTarget) {
						ajaxUtils(newTarget);
						checkFullRedirectDataAttribute(newTarget);
						checkFullRefresh(newTarget);
					}
				};

			case "replace-with":
			default:
				return function (targetSelector, data) {
					if (checkFullRedirectDirective(data)) return;
					$(targetSelector).replaceWith(data);
					var context = targetContainer.children(targetIndex).addBack();
					ajaxUtils(context);
					checkFullRedirectDataAttribute(context);
					checkFullRefresh(context);
				};
		}

		function checkFullRedirectDirective(data) {
			if (!data) return false;
			var directiveName = '::ajax:full-redirect:';
			data = (data + '').trimLeft();
			if (data.startsWith(directiveName)) {
				var url = data.substr(directiveName.length);
				return redirectIfNotNull(url);
			}
			return false;
		}
		function checkFullRedirectDataAttribute(context) {
			var url = $('.ajax-full-redirect', context).data('ajax-full-redirect-url');
			return redirectIfNotNull(url);
		}
		function redirectIfNotNull(url) {
			if (url) {
				document.location.assign(url);
				return true;
			}
			return false;
		}
		function checkFullRefresh(context) {
			var frQuery = $(".ajax-full-refresh", context);
			if (frQuery.length > 0) {
				fullRefreshLocation = frQuery.data('ajax-full-refresh-location');
				fullRefreshAfterResponse = true;
			}
			if (fullRefreshAfterResponse) {
				if (fullRefreshLocation) location.assign(fullRefreshLocation);
				else location.reload();
			}
		}
	}

	$('div[data-ajax-autoload-url]', container).each(function (index, element) {
		function getParam(key) {
			return getAjaxParam(element, key);
		}

		var url = getParam('ajax-autoload-url');
		var httpMethod = getParam('ajax-method');
		if (httpMethod) httpMethod = (httpMethod + "").toUpperCase();
		if (!httpMethod) httpMethod = 'GET';
		var target = $(element);
		var updateMethod = getUpdateMethod(target);

		$.ajax({
			url: url,
			method: httpMethod,
			context: { noHistoryUpdate: true },
			success: function (data) {
				updateMethod(target, data);
			}
		});
	});

	$('a.ajax-link, .ajax-link a', container).each(function (index, link) {
		function getParam(key) {
			return getAjaxParam(link, key);
			//return $(link).data(key) || $(link).closest('.ajax-link').data(key);
		}

		var target = getParam('ajax-target');
		var fullRefreshAfterResponse = getParam('ajax-full-refresh');
		var related = getParam('ajax-refresh-related');
		var httpMethod = getParam('ajax-method');
		if (httpMethod) httpMethod = (httpMethod + "").toUpperCase();
		if (!httpMethod) httpMethod = 'GET';
		var updateMethod = getUpdateMethod(target);
		var noAutoScrollTop = getParam('ajax-no-autoscroll');
		var noHistoryUpdate = getParam('ajax-no-history-update'); 
		var offsetTop = target && $(target).length > 0 && $(target).offset().top;
		var href = $(link).attr('href');
		if (!href || (!target && httpMethod === 'GET')) return;

		$(link).click(function (ev) {
			function getFormData() {
				$link = $(link);
				var data = $("input", $link).serialize();
				var relatedInputs = $link.data('ajax-related-inputs');
				if (relatedInputs) {
					var extraData = $("input", $(relatedInputs)).serialize();
					if (!data) return extraData;
					if (extraData) return data + '&' + extraData;
				}
				return data;
			}

			ev.preventDefault();
			$.ajax({
				url: href,
				method: httpMethod,
				//data: httpMethod === 'POST' ? getFormData() : null,
				data: getFormData(),
				context: { noHistoryUpdate: noHistoryUpdate },
				success: function (data) {
					if (fullRefreshAfterResponse) location.reload();
					updateMethod(target, data);
					//var newTarget = $(target);
					//if (newTarget) ajaxUtils(newTarget);
					if (related) refreshPanel(related);
					if (!noAutoScrollTop) scrollTop(offsetTop);
				}
			});
		});
	});

	function scrollTop(position) {
		if (ajaxUtilsSettings.scrollToTopOfTargetContainer) {
			position += ajaxUtilsSettings.scrollTopDelta;
			if (position < 0) position = 0;
		}
		else position = 0;
		$('html,body').animate({ scrollTop: position }, 500);
	}

	$('.ajax-form', container).each(function (index, form) {
		var target = $(form).data('ajax-target');
		var related = $(form).data('ajax-refresh-related');
		var refreshIfEmpty = $(form).data('ajax-refresh-if-empty');
		var noAutoScrollTop = $(form).data('ajax-no-autoscroll');
		var noHistoryUpdate = $(form).data('ajax-no-history-update');
		//var dataType = $(form).data('ajax-data-type');

		if (target) target = $(target);
		else target = $(form);
		var updateMethod = getUpdateMethod(target);
		//var targetContainer = target.parent();
		//var targetIndex = target.index();
		var offsetTop = target && $(target).length > 0 && target.offset().top;

		$(form).ajaxForm({
			//target: target,
			//replaceTarget: true,
			context: { noHistoryUpdate: noHistoryUpdate },
			//dataType: dataType,
			//type: 'post',
			error: function () {
				fullRefreshAfterResponse = false;
			},
			success: function (data) {
				updateMethod(target, data);
				//var frQuery = $(".ajax-full-refresh", targetContainer);
				//if (frQuery.length > 0) {
				//	fullRefreshLocation = frQuery.data('ajax-full-refresh-location');
				//	fullRefreshAfterResponse = true;
				//}
				//if (fullRefreshAfterResponse) {
				//	if (fullRefreshLocation) location.assign(fullRefreshLocation);
				//	else location.reload();
				//}
				//ajaxUtils(targetContainer.children(targetIndex).addBack());

				if (related && (!refreshIfEmpty || data == '')) refreshPanel(related);

				if (!noAutoScrollTop) scrollTop(offsetTop);
				$(".loader-overlay").hide();
			},
			beforeSubmit: function (formData, jqForm, options) {
				$(".loader-overlay"/*, $(form)*/).show();
				return true;
			}
		});
	});

	function refreshPanel(selector) {
		$(selector).each(function (index, panel) {
			var $panel = $(panel);
			var updateMethod = getUpdateMethod($panel);
			var noHistoryUpdate = $panel.data('ajax-no-history-update');
			//var targetContainer = $panel.parent();
			//var targetIndex = $panel.index();

			var refreshUrl = $panel.data('ajax-refresh-action');
			$.ajax({
				// il metodo deve essere GET
				method: 'GET',
				url: refreshUrl,
				context: { noHistoryUpdate: noHistoryUpdate }
			}).done(function (data) {
				updateMethod(panel, data);
				//$panel.replaceWith(data);
				//ajaxUtils(targetContainer.children(targetIndex).addBack());
			});
		});
	}
}
